/**
 * Parse the raw text of a non-negative whole-number input (package limits).
 * Only plain digits are accepted: "1e2", "1.5", "-1", "-" are invalid, never silently normalized.
 * Surrounding whitespace is ignored; leading zeros are fine ("07" = 7).
 */
export type IntegerInputResult =
  | { kind: 'empty' }
  | { kind: 'ok'; value: number }
  | { kind: 'invalid' };

export const parseIntegerInput = (raw: string): IntegerInputResult => {
  const trimmed = raw.trim();
  if (trimmed === '') return { kind: 'empty' };
  if (!/^\d+$/.test(trimmed)) return { kind: 'invalid' };
  const value = Number(trimmed);
  return Number.isSafeInteger(value) ? { kind: 'ok', value } : { kind: 'invalid' };
};
